import { render, staticRenderFns } from "./AnomalyDescription.vue?vue&type=template&id=400a1e8e&scoped=true&"
import script from "./AnomalyDescription.vue?vue&type=script&lang=js&"
export * from "./AnomalyDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400a1e8e",
  null
  
)

export default component.exports